import FORMULAS from '../../../../utils/fomulas';
import PIPELINE_STEPS from '../../../../utils/pipeline_steps';
import ColumnModel from '../../../datasource/column';
import TableModel from '../../../datasource/table';
import PipelineStep from '../pipeline_step_model';
import {isNaN} from "lodash";

export default class AddColumnStepModel extends PipelineStep {
    name = 'Add Column';
    type = PIPELINE_STEPS.ADD_COLUMN;

    formula = FORMULAS.RUNNING_TOTAL;
    formulaArgs = {};

    constructor({formula = FORMULAS.ADD, formulaArgs = {}, ...otherProps} = {}) {
        super(otherProps);
        this.formula = formula;
        this.formulaArgs = {
            srcColumn: this.pipeline.getResultForStep(this.parents[0]).table.columns[0].id,
            columnName: '',
            ...formulaArgs,
        };
    }

    getDisplay() {
        const {srcColumn, amount} = this.formulaArgs;
        const results = this.pipeline.getResultForStep(this.parents[0]);
        return this.formula.getLabel({
            amount,
            column: results.table.getColumnById(srcColumn).label,
        });
    }

    setFormula(formula) {
        this.formula = formula;
    }

    setArg(name, value) {
        if (!isNaN(value)) {
            this.formulaArgs[name] = value;
        }
    }

    getArg(name) {
        return this.formulaArgs[name];
    }

    resetArgs() {
        this.formulaArgs = {};
    }

    apply(table) {
        const newTable = new TableModel(table);
        const newColumn = new ColumnModel({
            name: this.formulaArgs.columnName || 'New Column',
            type: 'number',
            sample: [],
        });
        newTable.addColumn(newColumn);

        if (!this.formulaArgs.srcColumn) {
            return {before: table, after: newTable, table: newTable, incomplete: true};
        }

        const column = table.getColumnById(this.formulaArgs.srcColumn);
        if (!column) {
            return {before: table, after: newTable, table: newTable, error: true};
        }

        const newValues = this.formula.apply(column.sample, this.formulaArgs);
        newColumn.sample = newValues;
        return {before: table, after: newTable, table: newTable, incomplete: !newValues || !this.formulaArgs.columnName};
    }
}
